import {IVendorOffer} from "../../offer/types/VendorOffer";

export function isActiveVendorOffer(offer: IVendorOffer) {
    return !offer.configuration.limited_presentation && offer.is_active;
}
import {IVendorOffer} from "../../offer/types/VendorOffer";

export function isActiveVendorOffer(offer: IVendorOffer) {
    return !offer.configuration.limited_presentation && offer.is_active;
}
